import { ActionIcon } from '@mantine/core';
import styled, { useTheme } from 'styled-components';
import type { IconName } from '../../../icon/icon';
import { Icon } from '../../../icon/icon';
import { IconScale } from '../../../icon/types';

interface TablePaginationIconProps {
  icon: IconName;
  title: string;
  onClick: () => void;
  disabled: boolean;
}

export const TablePaginationIcon = ({
  icon,
  title,
  onClick,
  disabled,
}: TablePaginationIconProps) => {
  const theme = useTheme();

  return (
    <StyledActionIcon
      variant="transparent"
      onClick={onClick}
      disabled={disabled}
      title={title}
    >
      <Icon
        name={icon}
        color={
          disabled ? theme.palette.neutral[60] : theme.palette.primary.main
        }
        scale={IconScale.S}
      />
    </StyledActionIcon>
  );
};

const StyledActionIcon = styled((props) => <ActionIcon {...props} />)`
  &:disabled {
    background-color: transparent;
  }

  svg {
    display: block; // Prevent weird extra margin
  }
`;
